import { render, staticRenderFns } from "./BaseSwitcher.vue?vue&type=template&id=7459781c&scoped=true&"
import script from "./BaseSwitcher.vue?vue&type=script&lang=js&"
export * from "./BaseSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwitcher.vue?vue&type=style&index=0&id=7459781c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7459781c",
  null
  
)

export default component.exports